import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import "./DislikeIcon.css";
import { Get_Feedback } from "../../../api/api";

export interface DislikePopupProps {
  onClose: () => void;
  message_id?: string;
}

export const DislikePopup: React.FC<DislikePopupProps> = ({
  onClose,
  message_id,
}) => {
  const [selectedReasons, setSelectedReasons] = useState<string[]>([]);
  const [additionalFeedback, setAdditionalFeedback] = useState("");
  const [loading, setLoading] = useState(false);
  const [validationError, setValidationError] = useState<string | null>(null);
  const [feedbackStatus, setFeedbackStatus] = useState<
    "success" | "error" | null
  >(null);

  useEffect(() => {
    if (feedbackStatus) {
      const timer = setTimeout(() => {
        onClose();
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [feedbackStatus, onClose]);

  const handleReasonSelect = (reason: string) => {
    const isSelected = selectedReasons.includes(reason);
    if (isSelected) {
      setSelectedReasons(selectedReasons.filter((r) => r !== reason));
    } else {
      setSelectedReasons([...selectedReasons, reason]);
    }
  };

  // const handleSubmit = async () => {
  //   setLoading(true);
  //   setAdditionalFeedback("");
  //   setSelectedReasons([]);
  //   const FeedBack_Response = await Get_Feedback(
  //     message_id,
  //     selectedReasons,
  //     additionalFeedback
  //   );
  //   console.log("Feeback", FeedBack_Response.status);

  //   if (FeedBack_Response.status === 200) {
  //     setFeedbackStatus("success");
  //   } else {
  //     setFeedbackStatus("error");
  //   }
  //   setLoading(false);
  // };

  
  const handleSubmit = async () => {
  if (selectedReasons.length === 0 && !additionalFeedback.trim()) {
    setValidationError("Please select at least one reason or provide additional feedback.");

    //    setTimeout(() => {
    //   setValidationError(null);
    // }, 3000); 
    return;
  }

  setValidationError(null); 
  setLoading(true);

  try {
    const FeedBack_Response = await Get_Feedback(
      message_id,
      selectedReasons,
      additionalFeedback
    );

    if (FeedBack_Response.status === 200) {
      setFeedbackStatus("success");
      setSelectedReasons([]);
      setAdditionalFeedback("");
    } else {
      setFeedbackStatus("error");
    }
  } catch (error) {
    console.error("Error submitting feedback:", error);
    setFeedbackStatus("error");
  }

  setLoading(false);
};


  return (
    <Modal
      open={true}
      onClose={onClose}
      aria-labelledby="feedback-modal-title"
      aria-describedby="feedback-modal-description"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div className="modal-content">
        <button onClick={onClose} className="close-btn">
          X
        </button>
        <h3 id="feedback-modal-title" className="modal-title mb-2">
          Why did you choose this rating? (optional)
        </h3>
        <div className="button-group">
          <button
            className={`feedback-btnD ${
              selectedReasons.includes("offensive") ? "selected" : ""
            }`}
            onClick={() => handleReasonSelect("offensive")}
          >
            Offensive/Unsafe
          </button>
          <button
            className={`feedback-btnD ${
              selectedReasons.includes("not-factually-correct")
                ? "selected"
                : ""
            }`}
            onClick={() => handleReasonSelect("not-factually-correct")}
          >
            Not Factually Correct
          </button>
          <button
            className={`feedback-btnD ${
              selectedReasons.includes("others") ? "selected" : ""
            }`}
            onClick={() => handleReasonSelect("others")}
          >
            Others
          </button>
        </div>
        <textarea
          placeholder="Provide Additional Feedback (Optional) "
          value={additionalFeedback}
          onChange={(e) => setAdditionalFeedback(e.target.value)}
          className="feedback-textarea"
          maxLength={300}
        />

        {validationError && (
  <div className="validation-error">{validationError}</div>
)}
        <div style={{ marginTop: "10px" }}>
          {loading ? (
            <div className="loading-spinner"></div>
          ) : feedbackStatus === "success" ? (
            <div className="success-message">
              Feedback submitted successfully!  {/* <span style={{color:"#fff"}}>&#10004;</span> */}
            </div>
          ) : feedbackStatus === "error" ? (
            <div className="error-message">
              Failed to submit feedback! {/* <span style={{color:"#fff"}}>&#10008;</span> */}
            </div>
          ) : (
            <button className="submit-btn" onClick={handleSubmit}>
              Submit
            </button>
          )}
        </div>
      </div>
    </Modal>
  );
};



